

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

require('squid/index');

require('components/xo-beaver/dist/logger');

var _miniBrowser = require('js/lib/miniBrowser');

var _integration = require('js/lib/integration');

require('./fallback');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$contingencyHandler', function ($Contingency, $logger, $location, $feature, $state, $config, $meta, $window, $util, $populate, $q, $pxp, $AuthModel, $CheckoutCartModel, $CheckoutPayeeModel, $locale, $Forbidden, $rootScope, $FallbackError) {

    function showGenericError(code) {
        return function () {
            var encoded = code ? window.btoa(code) : code;
            $state.go('checkout.genericError', {
                code: encoded
            });
        };
    }

    function route(path) {
        return function () {
            $state.go(path, { message: arguments[0] });
        };
    }

    function forbidden(err) {
        throw new $Forbidden(err);
    }

    function fallback(product) {
        return function (err) {
            throw new $FallbackError({
                reason: err,
                product: product
            });
        };
    }

    function handleStepupAuth(code, authModel, step_up_context) {
        authModel.stepupAuthRequired = true;

        var reasons = {
            VERIFY_USER_IDENTITY: 'step_up_auth_needed',
            PAYER_AUTHENTICATION_REQUIRED: 'login_required'
        };

        if (authModel.remembered) {
            $logger.debug('PLANNING_STEP_UP_REMEBERED_USER');
            authModel.action('logout').then(function () {
                $state.go('checkout.login', {
                    targetPage: 'ONETOUCH_GENERIC_ERROR',
                    source: 'FRESH_START'
                });
            });
        } else if (step_up_context && !_angular2['default'].isObject(step_up_context)) {
            $logger.debug('PLANNING_STEP_UP_LOGIN_USER_TEST_TRAFFIC');

            var authChallengeNodeUrl = $config.urls.authChallengeNodeUrl;

            if ($config.deploy.isLocal() || $config.deploy.isStage()) {
                authChallengeNodeUrl = authChallengeNodeUrl.replace('www.paypal.com', $meta.stage);
            }

            authChallengeNodeUrl = $util.buildURL(authChallengeNodeUrl, {
                stepupContext: step_up_context,
                stsReturnUrl: $config.ulMeta.stsReturnUrl,
                returnUri: $config.ulMeta.authChallengeReturnUri + $window.location.search + '&atoSuccess',
                locale: $locale.lang,
                flowId: 'xo',
                flowContext: 'funding'
            });

            if (authChallengeNodeUrl) {
                $util.redirect(authChallengeNodeUrl);
            }
        } else {
            $logger.debug('PLANNING_STEP_UP_LOGIN_USER_CONTROL_TRAFFIC');
            throw new $FallbackError({
                reason: reasons[code],
                product: 'ux'
            });
        }
    }

    function handleMerchantBANocards(contingency) {
        var FALL_BACK_LIST = ['INSTANT_FUNDING_SOURCE_UPSELL_NEEDED', 'ELV_DECLINE', 'NEED_CREDIT_CARD', 'NEED_CONFIRMED_CARD', 'NEED_AUTHENTICATED_CARD', 'NEED_CREDIT_CARD_OR_BANK_ACCOUNT', 'EXPIRED_CREDIT_CARD'];

        if (FALL_BACK_LIST.indexOf(contingency.message) !== -1) {
            var _ret = function () {
                var models = {};

                return {
                    v: $populate(models, {
                        checkoutCart: $CheckoutCartModel.instance($rootScope.token),
                        payee: $CheckoutPayeeModel.instance($rootScope.token)
                    }).then(function () {
                        return $pxp('xo_hermes_ba_nocards', { 'uid': models.payee.merchant.id }, 'xo_hermesnode_ba_nocards_whitelist_treatment').then(function (result) {
                            if (result && models.checkoutCart.isBilling()) {
                                $logger.info('ba_nocard_contingency_triggered');
                                throw new $FallbackError({
                                    reason: 'fallback_merchant_BA_nocards',
                                    product: 'ux'
                                });
                            } else {
                                return $q.when();
                            }
                        });
                    })
                };
            }();

            if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
        } else {
            return $q.when();
        }
    }

    return function (contingency) {

        // Leave a footprint here. The subsequent state where log how it goes..
        $logger.warn('contingency_handler', contingency);

        return handleMerchantBANocards(contingency).then(function () {

            return contingency.handle({
                // Route
                ECONSENT_REQUIRED: route('checkout.econsent'),
                INSTANT_FUNDING_SOURCE_UPSELL_NEEDED: route('checkout.pageAddCardMeft.addCardFlow.addCard'),
                ELV_DECLINE: route('checkout.pageAddCard.addCardFlow.addCard'),
                NEED_CREDIT_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
                NEED_CONFIRMED_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
                NEED_AUTHENTICATED_CARD: route('checkout.updateCard.addCardFlow.addCard'),
                NEED_CREDIT_CARD_OR_BANK_ACCOUNT: route('checkout.pageAddFi.bank.add'),
                EXPIRED_CREDIT_CARD: route('checkout.updateCard.addCardFlow.addCard'),
                NEGATIVE_BALANCE_RECOVERY: route('checkout.negativeBalanceRecovery'),
                PHONE_NUMBER_REQUIRED: route('checkout.addPhone'),
                SEPA_MANDATE_ACCEPTANCE_NEEDED: route('checkout.review'),
                TAX_ID_REQUIRED: route('checkout.addTaxId'),
                NEED_SHIPPING_ADDRESS: route('checkout.pageAddShipping.addShipping'),

                NEED_DEBIT_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
                EXPIRED_DEBIT_CARD: route('checkout.updateCard.addCardFlow.addCard'),

                PAYER_AUTHENTICATION_REQUIRED: function PAYER_AUTHENTICATION_REQUIRED() {
                    $state.go('checkout.login', {
                        targetPage: 'PAYER_AUTHENTICATION_REQUIRED'
                    });
                },

                // Generic Error Pages
                RESTRICTED_USER: showGenericError('RESTRICTED_USER'),
                PAYEE_BLOCKED_TRANSACTION: showGenericError('PAYMENT_DENIED'),
                PAYMENT_ALREADY_DONE: showGenericError('PAYMENT_ALREADY_DONE'),
                PAYMENT_DENIED: showGenericError('PAYMENT_DENIED'),
                PAYEE_ACCOUNT_RESTRICTED: showGenericError('RESTRICTED_USER'),
                INVALID_RESOURCE_ID: showGenericError('INVALID_RESOURCE_ID'),
                EXPIRED_SESSION: showGenericError('EXPIRED_SESSION'),
                PAYER_CANNOT_PAY: showGenericError('PAYER_CANNOT_PAY'),
                PAYER_COUNTRY_NOT_ALLOWED: showGenericError('PAYER_COUNTRY_NOT_ALLOWED'),
                PAYER_COUNTRY_NOT_ENABLED: showGenericError('PAYER_COUNTRY_NOT_ENABLED'),
                PAYER_LOGIN_COUNTRY_NOT_ALLOWED: showGenericError('PAYER_LOGIN_COUNTRY_NOT_ALLOWED'),
                GAMING_FUNDING_SOURCE_VALIDATION_FAILED: showGenericError('GAMING_FUNDING_SOURCE_VALIDATION_FAILED'),
                COMPLIANCE_VIOLATION: showGenericError('COMPLIANCE_VIOLATION'),
                DOMESTIC_TRANSACTION_REQUIRED: showGenericError('DOMESTIC_TRANSACTION_REQUIRED'),
                INTERNAL_SERVICE_ERROR: showGenericError('TRANSACTION_REFUSED'),
                NEGATIVE_BALANCE_TRANSACTION_REFUSED: showGenericError('NEGATIVE_BALANCE_TRANSACTION_REFUSED'),
                ACCOUNT_CANNOT_BE_FETCHED: showGenericError('ACCOUNT_CANNOT_BE_FETCHED'),
                BAD_RESPONSE: showGenericError('DEFAULT'),
                TRANSACTION_REFUSED_LEGACY_FALLBACK: showGenericError('TRANSACTION_REFUSED'),
                RISK_DENIED: showGenericError('TRANSACTION_REFUSED'),

                // Non-specific errors - update with proper content ASAP
                AGREEMENT_ALREADY_CREATED: showGenericError('DEFAULT'),
                PAYMENT_NOT_APPROVED_FOR_EXECUTION: showGenericError('DEFAULT'),
                PAYER_ACCOUNT_LOCKED_OR_CLOSED: showGenericError('DEFAULT'),

                // This could be a generic error or fallback, depending on the country feature.
                UNSUPPORTED_PAYEE_CURRENCY: $feature('unsupportedPayeeCurrency') ? showGenericError('UNSUPPORTED_PAYEE_CURRENCY') : fallback('ux'),

                // Fallbacks
                SENDING_LIMIT_EXCEEDED: fallback('ux'),
                PAYMENT_CANNOT_BE_INITIATED: fallback('ux'),
                PERMISSION_DENIED: fallback('ux'),
                INVALID_TOKEN: fallback('ux'),
                INVALID_FUNDING_OPTION: fallback('ux'),
                VALIDATION_ERROR: fallback('ux'),
                SHIPPING_ADDRESS_INVALID: fallback('ux'),
                INVALID_ARGUMENT: fallback('ux'),
                CREDIT_PAYMENT_NOT_ALLOWED: fallback('ux'),
                PAYEE_ACCOUNT_LOCKED_OR_CLOSED: fallback('ux'),
                MALFORMED_REQUEST: fallback('ux'),
                TWOFA_INACTIVE: fallback('ux'),
                ERROR: fallback('ux'),
                ISSUER_DECLINE: fallback('ux'),
                UNSUPPORTED_CUP_SECURECARD: fallback('ux'),

                // Forbidden

                BUYER_NOT_SET: forbidden,

                // Other

                TRANSACTION_REFUSED: function TRANSACTION_REFUSED(message, data) {
                    var clearedRT = data.clearedRT;

                    if (clearedRT) {
                        $logger.info('checkout_fpti', {
                            from: 'CONTINGENCY',
                            to: 'process_fallback',
                            routing_reason: 'TRANSACTION_REFUSED'
                        });
                    }

                    // always go to generic error page, even if logout fails
                    $AuthModel.instance().action('logout')['finally'](showGenericError('TRANSACTION_REFUSED'));
                },

                PAYER_INVALID_FOR_PAYMENT: function PAYER_INVALID_FOR_PAYMENT() {
                    // Payer is not same payer checkout session was created for.
                    return $AuthModel.instance().action('logout')['finally'](function () {
                        $AuthModel.instance().invalidate();

                        return $state.go('checkout.login', {}, {
                            reload: true
                        });
                    });
                },

                CANNOT_PAY_SELF: function CANNOT_PAY_SELF() {
                    $AuthModel.instance().meta.selfPay = true;
                    $rootScope.contingency = {};
                    $rootScope.contingency.message = 'CANNOT_PAY_SELF';

                    return $state.go($state.current, {}, {
                        reload: true
                    });
                },

                VERIFY_USER_IDENTITY: function VERIFY_USER_IDENTITY(message, data) {
                    var clearedRT = data.clearedRT;

                    if (clearedRT) {
                        $logger.info('checkout_fpti', {
                            from: 'CONTINGENCY',
                            to: 'process_fallback',
                            routing_reason: 'VERIFY_USER_IDENTITY'
                        });
                    }

                    return handleStepupAuth('VERIFY_USER_IDENTITY', $AuthModel.instance(), data.step_up_context);
                },

                LOGIN_CONTINGENCY: function LOGIN_CONTINGENCY() {
                    if (_integration.$integration.getConfig('CAN_FRAMEBUST')) {
                        return _miniBrowser.$miniBrowser.frameBust($rootScope.token);
                    }

                    return fallback('ux');
                },

                DEFAULT: function logUnhandledContingency() {
                    $logger.warn('ui_unhandled_contingency_' + this.message);
                    throw new $FallbackError({
                        reason: 'unhandled_contingency',
                        product: 'ux'
                    });
                }
            });
        });
    };
});

_miniBrowser.$miniBrowser;

_integration.$integration;


//////////////////
// WEBPACK FOOTER
// ./js/lib/contingency.js
// module id = ./js/lib/contingency.js
// module chunks = 1